import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { thankValue, offensiveValue, poorValue } from 'Constants/constants'
import {
  StarYellowIcon,
  StarGreyIcon,
  HeartGreyIcon,
  AngryFaceGreyIcon,
  DislikeGreyIcon,
} from 'Stories/Icon/Icon.stories'
import { ArtistFeedback } from 'Types/index'

import { ArtistResponseProps } from './props'
import {
  Container,
  Title,
  RespondedContainer,
  RespondedRating,
  RespondedFeedback,
  ResponsePlaceholder,
  RespondedFeedbackRow,
  RespondedIcon,
} from './styles'

const Component: FunctionComponent<ArtistResponseProps> = ({
  reviewFeedback,
  curatorRating,
  isModal,
}) => {
  const { t } = useTranslation()

  const renderRespond = (feedback: ArtistFeedback): JSX.Element => {
    switch (feedback) {
      case thankValue:
      default:
        return (
          <>
            <RespondedIcon>
              <HeartGreyIcon />
            </RespondedIcon>
            <RespondedFeedback>
              {t('campaignResultsPage.thankYou')}
            </RespondedFeedback>
          </>
        )
      case offensiveValue:
        return (
          <>
            <RespondedIcon>
              <AngryFaceGreyIcon />
            </RespondedIcon>
            <RespondedFeedback>
              {t('campaignResultsPage.soundsOffensive')}
            </RespondedFeedback>
          </>
        )
      case poorValue:
        return (
          <>
            <RespondedIcon>
              <DislikeGreyIcon />
            </RespondedIcon>
            <RespondedFeedback>
              {t('campaignResultsPage.notUsefullFeedback')}
            </RespondedFeedback>
          </>
        )
    }
  }

  const renderRating = (rating: number): JSX.Element[] => {
    const ratingArray = Array.from({ length: 5 })
    for (let i = 0; i !== +rating; i += 1) {
      ratingArray[i] = true
    }
    return ratingArray.map(el => (el ? <StarYellowIcon /> : <StarGreyIcon />))
  }

  return (
    <Container isModal={isModal}>
      {curatorRating && reviewFeedback ? (
        <>
          <Title>{t('reviewsPage.responseFromArtist')}</Title>
          <RespondedContainer>
            {curatorRating && (
              <RespondedRating>{renderRating(curatorRating)}</RespondedRating>
            )}
            {reviewFeedback && (
              <RespondedFeedbackRow>
                {renderRespond(reviewFeedback)}
              </RespondedFeedbackRow>
            )}
          </RespondedContainer>
        </>
      ) : (
        <ResponsePlaceholder>
          {t('reviewsPage.responsePlaceholder')}
        </ResponsePlaceholder>
      )}
    </Container>
  )
}

export const ArtistResponse = React.memo(Component)
